import {
  Button,
  Typography,
  Dialog,
  DialogContent,
  Grid,
  DialogActions,
  TextField,
} from "@mui/material";

const ArchiveDeviceModal = ({
  open,
  handleClose,
  selectedDevice,
  handleArchive,
  loading,
}) => {
  if (!selectedDevice) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 500,
        },
      }}
    >
      <DialogContent sx={{ p: 4, pb: 2 }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: "Lexend",
            fontSize: "20px",
            mb: 3,
            fontWeight: 500,
            color: "383E49",
          }}
        >
          Archive the Device
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Lexend",
                fontSize: "14px",
                fontWeight: 500,
                color: "#48505E",
              }}
            >
              Device Name
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Lexend",
                fontSize: "14px",
                fontWeight: 500,
                color: "#858D9D",
              }}
            >
              {selectedDevice.name || "V2763946"}
            </Typography>
          </Grid>

          {/* <Grid item xs={4}>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Lexend",
                fontSize: "14px",
                fontWeight: 500,
                color: "#48505E",
              }}
            >
              Reason
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              // required
              fullWidth
              multiline
              rows={3}
              id="reason"
              label="Reason"
              name="reason"
              // value={deviceInfo.imei}
              // onChange={handleEmployeeInfoChange}
              variant="outlined"
            />
          </Grid> */}
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{ mr: 1, borderRadius: 1 }}
        >
          Cancel
        </Button>
        {selectedDevice.status !== "On Hold" && (
          <Button
            variant="contained"
            sx={{
              borderRadius: 1,
              backgroundColor: "#1366D9",
              "&:hover": {
                backgroundColor: "#0043a0",
              },
            }}
            onClick={handleArchive}
            disabled={loading}
          >
            Archive
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveDeviceModal;
